import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import isEmpty from 'lodash/isEmpty';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';

import messages from '../../messages';

interface Params {
  rejection_reason?: string;
  admin_comment?: string;
}

const retryFile = async ({
  type,
  fileUuid,
  params,
}: {
  type: string;
  fileUuid: string;
  params: Params;
}) => {
  let payload;

  if (!isEmpty(params)) {
    payload = { asset: { ...params } };
  }

  const res = await putRequest(
    API.PUT.retryVerificationFile(type, fileUuid),
    payload,
  );
  return res.data;
};

export const useUpdateRetryVerificationFile = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: retryFile,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.VERIFICATION_FILES],
      });
      handleSuccess(formatMessage(messages.declineDone));
    },
    onError: handleError,
  });
};
